module.exports = {
  CHANGE_LANG: 'CHANGE_LANG',
  SET_AV_LANGS: 'SET_AVAILABLE_LANGS',
};
